<template>
  <GlobalLoader />
  <router-view />
</template>

<script>
import GlobalLoader from '@/components/GlobalLoader.vue';
import { loadIntranetPhotos } from '@/plugins/intranetPhotos';

export default {
  components: { GlobalLoader },
  mounted() {
    loadIntranetPhotos();
  },
};
</script>

<style lang="scss">
// Import Main styles for this application
@import 'styles/style';
@import 'sweetalert2/src/sweetalert2.scss';
</style>
